import { sendMetrics } from "@expert/cloudwatch-metrics";
import { getLogger } from "@expert/logging";
import { trackFullStoryEvent } from "@expert/monitoring";

const logger = getLogger({ module: "trackTimeElapsed" });

export const APP_START = "appLoadStart";

function getNavigationType(): string {
    const entries = performance.getEntriesByType("navigation");
    if (entries.length > 0) {
        return (entries[0] as PerformanceNavigationTiming).type;
    }
    return "unknown";
}

export function trackTimeElapsed(mark: string, measure: string): void {
    const marks = performance.getEntriesByName(mark, "mark");
    if (marks.length === 0) {
        logger.warn(`${mark} not found, skipping measurement ${measure}`);
        return;
    }

    performance.clearMeasures(measure);
    const elapsed = performance.measure(measure, mark);
    const durationMs = Math.round(elapsed.duration);
    const navigationType = getNavigationType();

    logger.info({ durationMs, navigationType }, `Time from ${mark} to ${measure}`);

    void sendMetrics([
        {
            metrics: [{ name: "Duration", value: durationMs, unit: "Milliseconds" }],
            dimensions: { actionName: measure, navigationType },
        },
    ]);

    trackFullStoryEvent(measure, { durationMs, navigationType });
}
